import {
  ballsColorColumns,
  betTypeForBetName,
  betTypesForBetBetslip, colorsAsNumbers,
  EVEN_ODD,
  specifierValueForSpecialBets, UNDER_OVER
} from './constants';

export const getFloor = (originValue, signsAfterComma) => {
  let signsAfterComma_ = signsAfterComma;
  if (!signsAfterComma) signsAfterComma_ = 1;
  return Math.floor(originValue * signsAfterComma_) / signsAfterComma_;
};

export const isMobile = {
  Android: function() {
    return /Android/i.test(navigator.userAgent);
  },
  BlackBerry: function() {
    return /BlackBerry/i.test(navigator.userAgent);
  },
  iOS: function() {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
  },
  Opera: function() {
    return /Opera Mini/i.test(navigator.userAgent);
  },
  Windows: function() {
    return /IEMobile/i.test(navigator.userAgent);
  },
  any: function() {
    return (
      isMobile.Android() ||
      isMobile.BlackBerry() ||
      isMobile.iOS() ||
      isMobile.Opera() ||
      isMobile.Windows()
    );
  }
};

// get color name by ball number
export const getColorForNumber = (number) => {
  let colorName = "";
  for (const [color, numbers] of Object.entries(ballsColorColumns)) {
    if (Object.keys(numbers).includes(String(number))) {
      return color;
    }
  }
  return colorName;
}

// get odds by bet type
export const getOddByBetTypeAndSpecifier = (betType, winningPlan, specifier = -1) => {
  let odd;
  for (const oneBetPlan of winningPlan) {
    if (specifier != -1) {
      if (Number(oneBetPlan.BetType) === betType && Number(oneBetPlan.Specifier) === specifier) {
        odd = oneBetPlan.Value;
      }
    } else {
      if (Number(oneBetPlan.BetType) === betType) {
        odd = oneBetPlan.Value;
      }
    }

  }
  return odd;
}

// check if bet which will add in basket is already exist there
export const betAlreadyInBetsObject = (betsObject, bet) => {
  let betAlreadyInBetsObject = false;
  let betsObjectCopy = Object.assign({}, { ...betsObject });
  Object.keys(betsObjectCopy).forEach((eventId, i) => {
    if (betsObjectCopy[eventId]) {  
      betsObjectCopy[eventId].forEach(oneBet => {
        const oneBetProps = oneBet[Object.keys(oneBet)[0]];
        const betProps = bet[Object.keys(oneBet)[0]];
        if (!betProps) return false;
        if (oneBetProps.betType === betProps.betType && String(betProps.result)===String(oneBetProps.result)) betAlreadyInBetsObject = true;
      });
     
    }
  });
  return betAlreadyInBetsObject;
}


export const getBetTypeName = (betType)  => betTypesForBetBetslip[Object.keys(betTypeForBetName).filter((key) => betTypeForBetName[key] === betType)[0]]
export const getBetValueOfType = (betType: 0, betValues: [])  => {
  const evenOddTypes = [2,4,11]
  const underOverTypes = [3,5]
  const colorTypes = [10, 7, 8]
  if(evenOddTypes.includes(betType)) return [EVEN_ODD[betValues]]
  if(underOverTypes.includes(betType)) return [UNDER_OVER[betValues]]

  if(colorTypes.includes(betType)){
    let result = [];
    const listBetsValue = betValues.split(",").map(Number);
    for ( const [key, value] of Object.entries(colorsAsNumbers) ) {
      if(listBetsValue.includes(Number(value))) result.push(key)
    }
    return result;
  }
  return betValues.split(",").map(Number)
}